<template>
    <div
        @click="handleClick"
        class="radio-option"
        :class="{
            selected: isSelected,
            disabled: disabled,
        }"
    >
        <div class="option-radio">
            <div class="radio-outer" :class="{ checked: isSelected }">
                <div v-if="isSelected" class="radio-inner"></div>
            </div>
        </div>

        <div class="option-content">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    isSelected: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['click'])

const handleClick = () => {
    if (!props.disabled) {
        emit('click')
    }
}
</script>

<style scoped>
.radio-option {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    padding: 10px 11px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid #9B6E2B;
    background: transparent;
}

.radio-option:hover:not(.disabled) {
    border-color: rgba(155, 110, 43, 0.5);
    background: rgba(155, 110, 43, 0.05);
}

.radio-option.selected {
    border-color: #9B6E2B;
    background: #372A12;
}

.radio-option.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
}

.radio-outer {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #9B6E2B;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.2s ease;
}

.radio-outer.checked {
    border-color: #9B6E2B;
}

.radio-inner {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #9B6E2B;
    opacity: 0;
    transform: scale(0.5);
    transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.radio-outer.checked .radio-inner {
    opacity: 1;
    transform: scale(1);
}

.option-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
}
</style>
